import { faTimes, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { PrinterFill } from "react-bootstrap-icons";
import { makeDocumentsPermanet } from "../store/api/DocumentsAPI";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

const ModalPermanetDocuments = (props) => {
    const dispatch = useDispatch();
    const { handleSubmit, register } = useForm();
    const dateFilters = useRef({});
    const { popData, setPopData } = props;
    const { show } = popData;
    function close() {
        setPopData({ show: false })
    }
    function makeDocsPermanet(data) {
        data.PDateFrom = document.getElementsByName("DocPerm_DateFrom")[0].value;
        data.PDateTo = document.getElementsByName("DocPerm_DateTo")[0].value;
        if (data.PDateFrom !== "") {
            data.DateFrom = dateFilters.current.DateFrom;
        }
        if (data.PDateTo !== "") {
            data.DateTo = dateFilters.current.DateTo;
        }
        const onSuccess = (res) => {
            if (Number(res?.UpdateCount) >= 0) {
                const msg = `تعداد ${res.UpdateCount} سند تبدیل به دائمی شد`;
                setErrorDialog(dispatch, msg, "دائمی کردن سندها");
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "دائمی کردن سندها");
            }
        }
        makeDocumentsPermanet(data.DateFrom ?? "", data.DateTo ?? "", data.NumberFrom, data.NumberTo, onSuccess);
    }
    return (
        <Modal show={show} onHide={() => { }} >
            <Modal.Header className="headerStyle">
                <span><FontAwesomeIcon icon={faToggleOn} size="lg" />&nbsp;دائمی کردن سندهای حسابداری</span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(makeDocsPermanet)}>
                    <Row className="rowBorder">
                        <FormGroup className="col-md-6">
                            <label>از شماره: </label>
                            <Form.Control name="NumberFrom" ref={register({})} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>تا شماره: </label>
                            <Form.Control name="NumberTo" ref={register({})} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>از تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocPerm_DateFrom" onChange={value => dateFilters.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>تا تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocPerm_DateTo" onChange={value => dateFilters.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                        </FormGroup>
                    </Row>
                    <Button type="submit" className="group-Btn-large mt-1"><PrinterFill size={18} />&nbsp; دائمی کردن سندها</Button>
                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalPermanetDocuments;